import React from "react";
import PropTypes from "prop-types";

import { createModal } from "common/Modals";
import { heapTrack } from "lib/analytics";
import { staticURL } from "lib/img";

class MatchesUnlockedModal extends React.PureComponent {
    static propTypes = {
        hideModal: PropTypes.func.isRequired,
    };

    componentDidMount() {
        heapTrack("Matches Unlocked Modal - Show");
    }

    onDismiss = (event) => {
        event.preventDefault();

        this.props.hideModal();
        heapTrack("Matches Unlocked Modal - Dismiss");
    };

    render() {
        return (
            <div className="ws-modal ws-modal-tiny matches-unlocked-modal">
                <div className="ws-modal-body">
                    <img src={staticURL("matches-unlocked-illo.svg")} alt="matches unlocked" />
                    <div className="matches-unlocked-modal__header">
                        You&apos;ve unlocked Personalized Matches!
                    </div>
                    <div className="matches-unlocked-modal__subheader">
                        Jobs we think are a great fit for you will now show up in your Matches tab
                    </div>
                </div>
                <div className="ws-modal-footer">
                    <a href="/matches/" className="btn btn-primary btn-large">
                        Take a look now
                    </a>
                    <a href="#" onClick={this.onDismiss}>
                        Dismiss
                    </a>
                </div>
            </div>
        );
    }
}

export default createModal(MatchesUnlockedModal);
